<template>
  <div>
    <h1 class="p-5 text-center">Overview</h1>
    <GoalOverview />
    <VisionboardOverviewPage />
    <ChallengeCatalogPage />
  </div>
</template>

<script>
import GoalOverview from './GoalOverview'
import VisionboardOverviewPage from './VisionboardOverviewPage'
import ChallengeCatalogPage from './ChallengeCatalogPage'

export default {
  name: "OverviewPage",
  data: () => ({
  }),
  computed: {
  },
  methods: {
  },
  components: {
    GoalOverview,
    VisionboardOverviewPage,
    ChallengeCatalogPage,
  }
};
</script>

<style>
</style>
